import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "registry-add-to-cart",
  class RegistryAddToCart extends WYATTElement {
    constructor() {
      super();

      this.getAvailabilityForItem();
    }

    getAvailabilityForItem() {
      const endpoint = `${this.config.url}?variant=${this.config.variant_id}&view=registry-add-to-cart`;

      fetch(endpoint)
        .then((response) => response.text())
        .then((html) => {
          this.injectMessage(html);
        });
    }

    async injectMessage(html) {
      const placeholder = this.querySelector("[data-message]");

      placeholder.outerHTML = html;
    }
  },
);
